import { BLOCKS } from '@contentful/rich-text-types';
import { graphql } from 'gatsby';
import { Section } from '~components/Section';
import { MixedMedia } from '~components/MixedMedia';
import { renderParagraph, RichTextRenderer } from '~components/RichTextRenderer';

import * as styles from './ComponentImageTextGroup.module.css';

import type { ContentBlock } from '~components/types';
import type { ContentfulComponentImageTextGroup } from './types';

type ComponentImageTextGroupProps = {
  content: ContentfulComponentImageTextGroup;
};

export const ComponentImageTextGroup: ContentBlock<ComponentImageTextGroupProps> = ({
  content: { header, imageTextItems },
  ...sectionProps
}) => (
  <Section {...sectionProps} className={styles.section}>
    {header && <RichTextRenderer content={header.raw} wrapperElement='div' className={styles.header} />}
    <div className={styles.grid}>
      {imageTextItems.map(({ image, text }) => (
        <div key={text.raw} className={styles.gridItem}>
          <MixedMedia media={image} src={image.file.url} className={styles.media} />
          <RichTextRenderer
            content={text.raw}
            wrapperElement='div'
            className={styles.text}
            options={{
              renderNode: {
                [BLOCKS.HEADING_3]: (_, children) => <div className={styles.heading}>{children}</div>,
                [BLOCKS.HEADING_4]: (_, children) => <div className={styles.heading}>{children}</div>,
                [BLOCKS.PARAGRAPH]: renderParagraph({ className: styles.paragraph }),
              },
            }}
          />
        </div>
      ))}
    </div>
  </Section>
);

export const query = graphql`
  fragment ComponentImageTextGroup on ContentfulComponentImageTextGroup {
    __typename
    header {
      raw
    }
    imageTextItems {
      ...ComponentSharedImageText
    }
  }
`;
